<template>
  <div class="dashboard-promo-banner dashboard-promo-banner--timer" :class="{ open: isOpen }">
    <a :href="bannerLink" class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <img class="cheatgpt-logo" src="/static/img/cheatgpt-logo-mini-w.png" alt="">
          <div v-if="!joke" class="promo">
            <div class="promo-intro">
              {{ $gettext('CheatGPT - Launch date is 1st of April!') }}
            </div> 
            <div v-translate>
              Do keep in mind that due to the unusual date of release, you shouldn't count on too many savings! 🙂
            </div>
          </div>
          <div v-else class="promo promo-joke">
            <div class="promo-intro">
              {{ $gettext('April fools!') }}
            </div> 
            <div v-translate>
              We hope we did not get your hopes up too much. And to make sure that people who signed up for nothing are not too annoyed with us, we lowered prices on our yearly Premium subscription today by 20% (only for currently non-Premium subscriptions and only today). Keep in mind though, Gekko Premium is really nice, but not necessary to have a good Gekko experience. So it's up to you.
            </div>
          </div>
        </div>
        <div v-if="!joke" class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('Releasing in') }}</span>
            <FlipCount :time-until="promoEnds" />
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FlipCount from "@/components/dashboard/ui/FlipCount"
import moment from 'moment';
export default {
  name: 'PromoBannerAprils',
  components: {
    FlipCount
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      promoEnds: null,
      bannerType: null,
      debug: false
    }
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    }),
    bannerLink () {
      return '/subscriptions/manage/?selected=year'
    },
    joke () {
      return moment('2023-04-01').isSame(Date.now(), 'day')
    }
  },
  created () {
    if (this.promoData) {
      let dateformat = (this.preferredLanguage === 'en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
      this.promoEnds = moment(this.promoData.end_time).add(1, 'days').format(dateformat)
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
  .dashboard-promo-banner--timer {
    background-image: linear-gradient(to right top, #545094, #505b9b, #4e65a2, #4d6fa7, #4f79ab, #4883b0, #438cb3, #4295b5, #39a0b4, #3faaaf, #50b3a7, #69bb9d);
  }
</style>
